import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { MeasureListContextProvider } from '../../contexts/MeasureListContext';
import ReportDashboardSidebarNew from './ReportDashboardSidebarNew';
import ChartDashboardNew from '../../components/_report/dashboard/ChartDashboardNew';
// ----------------------------------------------------------------------
const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    // overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'unset',
    minHeight: '100%',
    width: 'calc(100% - 145px)',
}));

// ----------------------------------------------------------------------

export default function ReportDashboardNewLayout(props) {
    const [open, setOpen] = useState(true);
    const [selectedSidebarMenu, setSelectedSidebarMenu] = useState('Visualize');

    const onOpenSidebar = (menu) => {
        setOpen(true)
        setSelectedSidebarMenu(menu.title)
    }

    const onCloseSidebar = (menu) => {
        setOpen(false)
    }

    return (
        <>
            <RootStyle className="re-theme2">
                <MeasureListContextProvider>
                    <ReportDashboardSidebarNew
                        onOpenSidebar={onOpenSidebar}
                        isOpenSidebar={open}
                        onCloseSidebar={onCloseSidebar}
                        selectedSidebarMenu={selectedSidebarMenu}
                    />

                    <MainStyle className="report-new-wrapper">
                        <Outlet />
                        <ChartDashboardNew
                            isOpenSidebar={open}
                            menuItem={selectedSidebarMenu}
                            onOpenSidebar={onOpenSidebar}
                        />
                    </MainStyle>
                </MeasureListContextProvider>
            </RootStyle >
        </>
    );
}